<label class="add-revote-title">Create New Revote</label>
<div class="line-separator"></div>
<mat-horizontal-stepper [linear]="isLinear" #stepper>
    <mat-step [stepControl]="firstFormGroup" label="Name">
        <form [formGroup]="firstFormGroup">
            <div  class="flex-start flex-row" >
                <mat-form-field class="flex-40" >
                    <input [attr.data-testid]="'revote_name_text'" matInput required placeholder="Name"
                           formControlName="name" [pattern]="spaceValidatorPattern" class="flex-60" >
                    <mat-error *ngIf="firstFormGroup.controls['name'].invalid && !firstFormGroup.controls['name'].value"> Please enter a Name </mat-error>
                </mat-form-field>
            </div>
            <div  style="margin-top:30px;height:50px" class="flex-center-center">
                <button [attr.data-testid]="'cancel_button'" mat-raised-button matTooltip="Cancel"
                        (click)="onNoClick()" style="margin-right:60px" type="button" class="button-color">Cancel </button>
                <button [attr.data-testid]="'save_button'" mat-raised-button matTooltip="Next"
                        matStepperNext class="button-color">Next</button>
            </div>
        </form>
    </mat-step>
    <mat-step [stepControl]="secondFormGroup" label="Dates">
        <form [formGroup]="secondFormGroup">
            <div  class="flex-space-around flex-column" >
                <emm-effective-date-selection source="management"
                                              [label]="'Open Date'"
                                              [minDate]="tomorrowDate"
                                              (effectiveDateChange)="selectOpenDate($event)">
                </emm-effective-date-selection>
                <emm-effective-date-selection source="management"
                                              [label]="'Close Date'"
                                              [minDate]="closeMinDate"
                                              (effectiveDateChange)="selectCloseDate($event)">
                </emm-effective-date-selection>
                <emm-effective-date-selection source="management"
                                              [label]="'Effective date'"
                                              [minDate]="oneDayAfterCloseDate"
                                              (effectiveDateChange)="selectEffectiveDate($event)">
                </emm-effective-date-selection>
            </div>
            <div  style="margin-top:30px;height:50px" class="flex-center-center">
                <button [attr.data-testid]="'cancel_button'" mat-raised-button matTooltip="Cancel"
                        (click)="onNoClick()" style="margin-right:30px" type="button" class="button-color">Cancel </button>
                <button [attr.data-testid]="'back_button'" mat-raised-button matTooltip="back"
                        matStepperPrevious class="button-color" style="margin-right:30px">Back</button>
                <button [attr.data-testid]="'save_button'" mat-raised-button matTooltip="Next"
                        matStepperNext class="button-color">Next</button>
            </div>
        </form>
    </mat-step>
    <mat-step [stepControl]="thirdFormGroup" label="Categories">
        <form [formGroup]="thirdFormGroup">
            <mat-card appearance="outlined" style="height: 300px;">
                <mat-card-header style="display: block;">
                    Select Categories
                </mat-card-header>
                <mat-divider></mat-divider>
                <mat-card-content class="checkbox-card-content">
                    <mat-list class="ml-3" style="height: 220px; overflow: scroll;">
                        <mat-list-item  *ngFor="let category of categories | async" style="height: 40px;" class="flex-column">
                            <mat-checkbox formControlName="categories"
                                          (change)="updateAllSelected($event.checked, category)">
                                {{category.name}}&nbsp;-&nbsp;{{category.tag}}
                            </mat-checkbox>
                        </mat-list-item>
                    </mat-list>
                </mat-card-content>
            </mat-card>
            <div  style="margin-top:30px;height:50px" class="flex-center-center">
                <button [attr.data-testid]="'cancel_button'" mat-raised-button matTooltip="Cancel"
                        (click)="onNoClick()" style="margin-right:30px" type="button" class="button-color">Cancel </button>
                <button [attr.data-testid]="'back_button'" mat-raised-button matTooltip="back"
                        matStepperPrevious class="button-color" style="margin-right:30px">Back</button>
                <button [attr.data-testid]="'save_button'" mat-raised-button matTooltip="Next"
                        matStepperNext class="button-color">Next</button>
            </div>
        </form>
    </mat-step>
    <mat-step [stepControl]="finalFormGroup" label="Locations">
        <form [formGroup]="finalFormGroup">
            <mat-card-header style="display: block;">
                Select Locations
            </mat-card-header>
            <emm-cfa-data-table style="height:265px !important; display: block; overflow: scroll"
                            [getData]="getData.bind(this)" [dataColumns]="dataColumns"
                            [filterOptions]="filterOptions" [searchableOptions]="searchableOptions"
                            [searchPlaceholder]="'Search Locations'" [primaryKey]="'tag'"
                            [selectable]="true"
                            (selectionChange)="getSelectedLocations($event)">
            </emm-cfa-data-table>
            <div>
                <div  style="margin-top:30px;height:50px" class="flex-center-center">
                    <button [attr.data-testid]="'cancel_button'" mat-raised-button matTooltip="Cancel"
                            (click)="onNoClick()" style="margin-right:30px" type="button" class="button-color">Cancel </button>
                    <button [attr.data-testid]="'back_button'" mat-raised-button matTooltip="back"
                            matStepperPrevious class="button-color" style="margin-right:30px">Back</button>
                    <button [attr.data-testid]="'save_button'" mat-raised-button matTooltip="Next"
                            (click)="OnSubmit()" class="button-color">Save</button>
                </div>
            </div>
        </form>
    </mat-step>
</mat-horizontal-stepper>
